import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UnknownAction } from "redux";
import { AppState } from "../../store/types";
import { addQueueItems, removeQueueItems, updatePrintJob, updateQueueItem } from "./actions";
import { QueueDispatch, QueueState } from "./types";

export const useQueueState = (): QueueState =>
  useSelector(({ queue }: AppState) => {
    return queue;
  });

export const useQueueDispatch = (): QueueDispatch => {
  const dispatch = useDispatch();
  // typescript-fsa Action<T> lacks the index signature required by Redux 5's UnknownAction;
  // as unknown as UnknownAction is an intentional compatibility shim — migrate to RTK createAction to remove it.
  return useMemo(
    (): QueueDispatch => ({
      addQueueItems: (data) => dispatch(addQueueItems(data) as unknown as UnknownAction),
      updateQueueItem: (data) => dispatch(updateQueueItem(data) as unknown as UnknownAction),
      removeQueueItems: (data) => dispatch(removeQueueItems(data) as unknown as UnknownAction),
      updatePrintJob: (data) => dispatch(updatePrintJob(data) as unknown as UnknownAction),
    }),
    [dispatch],
  );
};
